export const PROJECT_NAME = 'User Manager Service';
export const SHORT_PROJECT_NAME = 'UMS';
